import { STORAGE_KEYS } from "../constants/defaults";

function canUseLocalStorage() {
  try {
    return typeof window !== "undefined" && !!window.localStorage;
  } catch {
    return false;
  }
}

function readJson(key, fallback) {
  if (!canUseLocalStorage()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // noop
  }
}

function readScalar(key, fallback = null) {
  if (!canUseLocalStorage()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw == null ? fallback : raw;
  } catch {
    return fallback;
  }
}

function writeScalar(key, value) {
  if (!canUseLocalStorage()) return;
  try {
    if (value == null) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, String(value));
  } catch {
    // noop
  }
}

// Mock repository adapter. Swap with API-backed repository later.
export const viewsRepositoryMock = {
  loadState() {
    return {
      views: readJson(STORAGE_KEYS.views, null),
      activeViewId: readScalar(STORAGE_KEYS.activeViewId, null),
    };
  },

  saveState({ views, activeViewId }) {
    if (Array.isArray(views)) writeJson(STORAGE_KEYS.views, views);
    if (typeof activeViewId !== "undefined") writeScalar(STORAGE_KEYS.activeViewId, activeViewId);
  },
};

export default viewsRepositoryMock;
